<template>
  <span
    :class="[ns.b(), ns.is('checked', checked)]"
    data-test-name="check-tag"
    data-test-variant=""
    data-test-state=""
    @click="handleChange"
  >
    <slot />
  </span>
</template>

<script lang="ts" setup>
import { CHANGE_EVENT } from '@bigin/constants'
import { useNamespace } from '@bigin/hooks'
import { checkTagEmits, checkTagProps } from './check-tag'

defineOptions({
  name: 'BCheckTag',
})
const props = defineProps(checkTagProps)
const emit = defineEmits(checkTagEmits)

const ns = useNamespace('check-tag')

const handleChange = () => {
  const checked = !props.checked
  emit(CHANGE_EVENT, checked)
  emit('update:checked', checked)
}
</script>
